export default __webpack_public_path__ + "../img/boosted_crm_logo.png";